import axios from 'axios';

const API = 'https://api.gmpapp.ru/gmp/generation';
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

// One request id per invocation: retrying a lost HTTP response cannot create
// a second generation. Engine keys and model credentials stay on the server.
export async function generateWithEngine(kind, payload) {
    const request_id = window.crypto.randomUUID();
    const body = { ...payload, request_id };
    let accepted;
    for (let attempt = 0; attempt < 3; attempt += 1) {
        try {
            accepted = await axios.post(`${API}/${kind}`, body, { timeout: 30000 });
            break;
        } catch (error) {
            if (error.response || attempt === 2) throw error;
            await sleep(1500);
        }
    }
    const deadline = Date.now() + 17 * 60 * 1000;
    while (Date.now() < deadline) {
        let status;
        try {
            status = (await axios.get(`${API}/${accepted.data.job_id}`, { timeout: 30000 })).data;
        } catch (error) {
            if (error.response && error.response.status < 500) throw error;
            await sleep(3000);
            continue;
        }
        if (status.status === 'success') return { data: status.result };
        if (status.status === 'failed') throw new Error(status.message || 'Не удалось сгенерировать пост.');
        await sleep(2000);
    }
    throw new Error('Ожидание затянулось. Проверьте список постов перед повторной генерацией.');
}

export function generationError(error) {
    return error.response?.data?.message || error.message || 'Не удалось сгенерировать пост. Попробуйте позже.';
}
